import React from 'react'

import { useSelectIntroDeal } from '@order/hooks/useDealTypeModal'

import { Deal, StrapiID } from '@ca/common/types'
import { useConfigConditionDealCheck } from 'features/config/useConfigCondition'
import DealComponent, { DealPlaceholder } from './Deal'
import { useCardFilter } from './useCardFilter'

const DealList = ({
  deals,
  onSelect,
  activeId,
}: {
  onSelect?: (deal: Deal) => void
  deals: Deal[]
  children?: React.ReactNode
  activeId?: StrapiID
}) => {
  const filter = useCardFilter({})
  const selectIntroDeal = useSelectIntroDeal()

  const checkDeal = useConfigConditionDealCheck()
  const select = onSelect ?? selectIntroDeal

  const handlePress = (deal: Deal) => {
    const isLink = checkDeal('intro:isLink', deal)
    if (!isLink && !deal.filter) {
      select(deal)
      return
    }

    const cardFilter = deal.filter ?? {
      tag: deal.code,
      type: undefined,
    }

    filter.setCardFilter(cardFilter)
  }

  return (
    <>
      {deals.map((deal, index) => (
        <DealComponent
          index={index}
          key={deal.id}
          deal={deal}
          grid={2}
          isActive={activeId === deal.id}
          onPress={() => handlePress(deal)}
        />
      ))}
      {deals.length % 2 === 1 && (
        <DealPlaceholder index={deals.length} grid={2} />
      )}
    </>
  )
}

export default DealList
